import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';
import { setWorkerUrl } from 'maplibre-gl';

/**
 * Tell MapLibre where its own worker lives.
 *
 * Without this the map draws its basemap and nothing else — no track, no
 * error, no warning in the console. MapLibre builds its worker URL at runtime
 * (roughly `new URL('./maplibre-gl-worker.mjs', import.meta.url)`, with the
 * filename assembled from a variable), which is a specifier Vite's static
 * analysis cannot see. So Vite never emits the worker file, the bundled
 * `import.meta.url` points at `/assets/`, the worker 404s, and every message
 * MapLibre sends it — including the one that turns the track's GeoJSON into
 * tiles — is simply never answered. Raster basemaps survive because they are
 * decoded on the main thread; anything vector or GeoJSON does not.
 *
 * `?worker&url` makes Vite bundle the worker (it imports the shared chunk, so
 * a plain `?url` copy would break on that import) and hand back a URL that
 * really exists in the build. MapLibre loads it with `{ type: 'module' }`,
 * which is why `vite.config.ts` sets `worker.format: 'es'`.
 *
 * Importing this module for its side effect, before the first `new Map(...)`,
 * is the whole contract.
 */
setWorkerUrl(workerUrl);
